// Keys whose VALUE must never be case-converted.
//
// `form_markup` is a JSON blob whose own keys are field names a Super Admin
// typed in the Inspection Form Builder — "The concrete placement does not
// comply, for the following reasons", "PE/AR License Number". They are DATA,
// not API field names, and the app converts every nested key of every response.
//
// That silently renamed the fields, and the two conversion layers did not even
// agree on the new name:
//
//   change-case   (axios, objectKeysToCamelCase) -> comma stripped
//   camelcase-keys (RTK Query, apiSlice)         -> comma kept
//
// So the form template arrived with one key and the inspection's saved answers
// with another. They stopped matching, the field rendered blank, and the next
// save wrote a THIRD copy under the newly mangled name — which is why page 2 of
// Threshold Concrete grew from 7 keys to 10 while the inspector's text kept
// disappearing. Keys that are plain letters (page 1) survive both converters
// unchanged, which is why only some fields ever broke.
//
// Both spellings are listed because the value is skipped AFTER its own key has
// been converted, and this runs in both directions.
export const OPAQUE_VALUE_KEYS = new Set(['form_markup', 'formMarkup']);

export const isOpaqueValueKey = (key: string): boolean =>
  OPAQUE_VALUE_KEYS.has(key);
